import Navbar from './Navbar'
import Hero from './Hero'
import SobreMi from './About'
import Cursos from './Cursos'
import ProximosCursos from './ProximosCursos'
import Mentorias from './Mentorias'
import Testimonios from './Testimonios'
import FAQ from './FAQ'
import Footer from '../layout/Footer'
import WhatsAppFloat from './WhatsAppfloat'

export default function Home() {
  return (
    <div style={{ background: 'var(--bg)', color: 'var(--ink)' }}>
      <Navbar />
      <Hero />
      <SobreMi />
      <Cursos />
      <ProximosCursos />
      <Mentorias />
      <Testimonios />
      <FAQ />
      <WhatsAppFloat />
    </div>
  )
}